import AppDBStorage from '@Services/AppDBStorage';

class StructureContainersStorage extends AppDBStorage {
  constructor() {
    super('structureContainers_');
  }

  getDefaultValue = () => ({});
}

export default new StructureContainersStorage();
